import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-0 bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative bg-[#FAF7F2] min-h-[600px] flex items-end p-12">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://public.readdy.ai/ai/img_res/bb21a30da596137889e0067c5ca16a18.jpg)',
              width: '800px',
              height: '900px',
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          <div className="relative z-10">
            <span className="inline-block text-sm text-white/90 mb-4 font-medium">Ready to Begin?</span>
            <h2 className="text-7xl font-bold text-white leading-tight">
              Start Your<br />El Paso<br />Journey
            </h2>
          </div>
        </div>

        <div className="bg-white min-h-[600px] flex flex-col items-center justify-center p-12 lg:p-16">
          <div className="max-w-md text-center space-y-8">
            <h3 className="text-5xl font-bold text-gray-900 leading-tight">
              Access Free Resources<br />&amp; Expert Guidance
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" style={{ lineHeight: '1.7' }}>
              Join hundreds of successful El Paso entrepreneurs who have launched their businesses with our comprehensive resources, local expertise, and supportive community. Everything you need to succeed is right here.
            </p>
            <Link
              to="/resources"
              className="inline-flex items-center space-x-3 bg-[#3D2817] text-white px-10 py-4 rounded-full font-semibold hover:bg-[#2D1F12] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <span>Explore Resources</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}